"use client";

import { useState } from "react";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/AuthContext";
import { PublicSessionProvider } from "@/contexts/PublicSessionContext";
import { AuthFlow } from "@/components/auth/auth-flow";
import { ReferralBanner } from "@/components/referral-banner";

export default function BlogLayoutClient({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  const [isCollapsed] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    const saved = localStorage.getItem("sidebar:state");
    return saved !== "true";
  });

  return (
    <PublicSessionProvider>
      <AuthFlow>
        <div className="flex flex-col h-dvh">
          <ReferralBanner />
          <SidebarProvider defaultOpen={!isCollapsed} className="flex-1 min-h-0">
            <AppSidebar />
            <SidebarInset>{children}</SidebarInset>
          </SidebarProvider>
        </div>
      </AuthFlow>
    </PublicSessionProvider>
  );
}
